import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = ['Intentaste duplicar el lotaje para salir del bache rápido, pero solo duplicaste tu ansiedad.', "Ignoraste tus indicadores para entrar 'por instinto', operando en zonas de ruido.", 'Te quedaste pegado a la pantalla esperando un milagro que nunca llegó.', "Trataste de 'ganarle' al mercado cuando el mercado simplemente estaba en una fase distinta a tu estrategia."];
export const Failures = () => {
  return <section className="py-16 md:py-24 bg-brand-bg relative border-t border-white/5" data-id="element-24">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-26">
          <h2 className="text-3xl sm:text-4xl md:text-5xl mb-3 md:mb-4 px-2" data-id="element-27">
            POR QUÉ LO QUE INTENTASTE{' '}
            <span className="text-brand-red" data-id="element-28">NO FUNCIONÓ</span>
          </h2>
          <p className="text-sm md:text-base text-gray-400 font-mono" data-id="element-29">
            Análisis de fallos comunes post-pérdida
          </p>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-30">
          {failures.map((failure, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 bg-brand-surface/50 p-4 md:p-6 rounded-lg border border-white/5 hover:border-brand-red/30 transition-colors" data-id="element-31">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-brand-red shrink-0 mt-0.5 md:mt-1" data-id="element-32" />
              <p className="text-base md:text-lg text-gray-300 line-through decoration-brand-red/50 decoration-2" data-id="element-33">
                {failure}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};